<template>
  <header class="header--container" :class="{ 'hide--subpage': !loggedIn }" ref="headerLayout">
    <div class="header--main-row d-flex justify-space-between align-center container">
      <div class="header--menu" @click="openSidebar()">
        <div style="position: relative">
          <img src="@/assets/img/icons/menu.svg" />
          <div v-if="enquiriesUnreadCount" class="unread--counter">
            {{ enquiriesUnreadCount }}
          </div>
        </div>
      </div>
      <div class="header--logo">
        <router-link to="/">
          <img :src="logoUrl" alt="BeliRumah" />
        </router-link>
      </div>
      <div class="header--right d-flex align-center">
        <div class="hide--in-mobile">
          <div class="header--top-links d-flex align-center">
            <!--            <header-project-type></header-project-type>-->
            <!--            <router-link-->
            <!--              to="/project/add"-->
            <!--              class="mr-4-5"-->
            <!--              @click="!loggedIn ? showLogin() : goToAddProject('R')"-->
            <!--            >-->
            <!--              {{ $t('general.entrustProperty') }}-->
            <!--            </router-link>-->
            <!--            <div class="mr-4-5" style="cursor: pointer;" @click="goToSearch('rumah')">-->
            <!--              {{ $t('general.buyHouse') }}-->
            <!--            </div>-->
            <!--            <div class="mr-4-5" style="cursor: pointer;" @click="goToSearch('apartemen')">-->
            <!--              {{ $t('general.buyApartment') }}-->
            <!--            </div>-->
            <!--            <a href="/kalkulator" class="mr-4-5">-->
            <!--              {{ $t('general.mortgage') }}-->
            <!--            </a>-->
            <!--            <a href="/mitra-agen" class="mr-4-5">-->
            <!--              {{ $t('general.agentPartner') }}-->
            <!--            </a>-->
            <!--            <a href="/mitra-proyek" class="mr-4-5">-->
            <!--              {{ $t('general.developerPartner') }}-->
            <!--            </a>-->
            <a href="https://komunitas.belirumah.co" target="_blank" class="header--top-link">
              {{ $t('footer.company.forum') }}
            </a>
            <router-link to="/iklan-properti" class="header--top-link">
              {{ $t('general.agentOfferings') }}
            </router-link>
            <router-link
              v-if="showConnectIntroLinks"
              to="/layanan-agen/owner-connect/cara-kerja"
              class="header--top-link"
            >
              {{ $t('home.sidebarMenu.ownerConnect') }}
            </router-link>
            <router-link
              v-if="showConnectIntroLinks"
              to="/layanan-agen/project-connect/cara-kerja"
              class="header--top-link"
            >
              {{ $t('home.sidebarMenu.projectConnect') }}
            </router-link>
          </div>
        </div>
        <div class="buttons hide--in-mobile" v-if="loggedIn">
          <!--            <header-inbox></header-inbox>-->
          <!--            <header-notifications></header-notifications>-->
          <header-user></header-user>
        </div>
        <div class="hide--in-mobile" v-else>
          <div class="btn btn-primary" @click="showLogin">
            {{ $t('loginRegister.title') }}
          </div>
        </div>
      </div>
    </div>
    <header-categories v-if="loggedIn"></header-categories>
  </header>
</template>

<script>
// import HeaderProjectType from '@/components/layouts/partials/header-project-type';
// import HeaderInbox from '@/components/layouts/partials/header-inbox';
// import HeaderNotifications from '@/components/layouts/partials/header-notifications';
import HeaderUser from '@/components/layouts/partials/header-user';
import HeaderCategories from '@/components/layouts/partials/header-categories';
import { mapGetters, mapState } from 'vuex';

export default {
  mixins: [],
  components: {
    // HeaderProjectType,
    // HeaderInbox,
    // HeaderNotifications,
    HeaderUser,
    HeaderCategories,
  },
  computed: {
    ...mapState({
      logoUrl: (state) => state.global.logoUrl,
      loggedIn: (state) => state.global.loggedIn,
      propertyTypes: (state) => state.masters.propertyTypes,
      enquiriesUnreadCount: (state) => state.global.enquiriesUnreadCount,
    }),
    ...mapGetters({
      isProOrExecutive: 'global/isProOrExecutive',
    }),
    showConnectIntroLinks() {
      return !this.loggedIn || !this.isProOrExecutive;
    },
  },
  async mounted() {
    this.$store.commit('global/SET_HEADER_LAYOUT', this.$refs.headerLayout);
  },
  methods: {
    showLogin() {
      this.$modal.show('modal-login');
    },
    // eslint-disable-next-line no-unused-vars
    async goToAddProject(type) {
      this.$router.push({
        path: `/project/add`,
        // query: query,
      });
    },
    openSidebar() {
      this.$store.commit('global/SET_MAIN_SIDEBAR', true);
    },
    async goToSearch(propertyTypeName) {
      try {
        let propertyType = null;
        if (propertyTypeName && propertyTypeName.toLowerCase() !== 'semua-tipe-properti') {
          propertyType = await this.propertyTypes.find(function (item) {
            return item && item.name
              ? item.name.toLowerCase() === propertyTypeName.toLowerCase()
              : false;
          });
          if (propertyType) propertyType = JSON.parse(JSON.stringify(propertyType));
        }
        this.$store.commit('v2/search/SET_SELECTED_PROPERTY_TYPE', propertyType);
        await this.$store.dispatch('v2/search/goToSearchPage', {
          router: this.$router,
          params: this.$route.params,
          query: {},
        });
      } catch (e) {
        console.log('ERROR GOING TO SEARCH PAGE: ', e);
      }
    },
  },
};
</script>
